import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryData } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="gallery-section py-20 md:py-32 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            {galleryData.title}
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-80">
            {galleryData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {galleryData.images.map((image) => (
            <div 
              key={image.id}
              className="gallery-item rounded-3xl overflow-hidden cursor-pointer group"
              onClick={() => setSelectedImage(image)}
              style={(image.id === 1 || image.id === 9) ? { gridColumn: 'span 2' } : {}}
            >
              <div className="gallery-image-wrapper">
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="gallery-image"
                />
                <div className="gallery-overlay">
                  <p className="gallery-caption text-xl font-semibold">
                    {image.caption}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div 
          className="gallery-modal"
          onClick={() => setSelectedImage(null)}
        >
          <div className="gallery-modal-content">
            <button 
              className="gallery-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              <X className="h-6 w-6" />
            </button>
            <img 
              src={selectedImage.url} 
              alt={selectedImage.alt}
              className="gallery-modal-image"
            />
            <p className="gallery-modal-caption">
              {selectedImage.caption}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
